export default String.raw`
<section class="search-advanced-container">
	<div class="search-advanced-container__search">
		<div class="search-advanced-container__search-phrase">
			<input aria-label="{{translations.SearchPhrase}}" type='search' name='search' placeholder="{{translations.SearchPhrase}}"
			class="search-advanced-container__search-phrase-input advanced-search-input-js" maxlength="100" >
			<svg tabindex="0" role="button" aria-label="{{ translations.Delete }}" class="search-advanced-container__search-phrase-delete clear-search-js hidden-js">
				<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{ settings.iconStyle }}'></use>
			</svg>
		</div>
		<div tabindex="0" class="search-advanced-container__search-categories select-js select">
			<select id="search-categories" class="memory-js" aria-label="{{ translations.AllCategories }}">
				<option value="">{{ translations.AllCategories }}</option>
				{% for option in page.GroupNodes -%}
					{%- assign t = option.Id | Split:',' -%}
					<option value="{{ t[1] }}">{{ option.Name }}</option>
				{% endfor -%}
			</select>
			<div class="select__input">
				<span class="selected-js" style="height: 24px;">{{ translations.AllCategories }}</span>
				<svg>
					<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{ settings.iconStyle }}'></use>
				</svg>
			</div>
			<ul tabindex="-1" class="select__options options-js">
				<li tabindex="-1" data-value="">{{ translations.AllCategories }}</li>
				{% for option in page.GroupNodes -%}
					{%- assign t = option.Id | Split:',' -%}
					<li tabindex="-1" data-value="{{ t[1] }}">{{ option.Name }}</li>
				{% endfor -%}
			</ul>
		</div>
	</div>

	<h4>{{ translations.FindResultsWhichHave }}</h4>

	<div class="search-advanced-container__find-by checkBoxes__container checkBoxes__container--radio">
		<div>
			<input id="default-search" aria-label="tos-search" name="tos" type="radio" class='search-radio-js' value='search' checked>
			<label role="radio" tabindex="0" for="default-search">
				<span class="checkBoxes__checkIcon">
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
						<circle cx="12" cy="12" r="8"/>
					</svg>
				</span>
				<span>{{translations.WithSequence}}</span>
			</label>
		</div>
		<div>
			<input id="searchAll" aria-label="tos-searchall" name="tos" type="radio" class='search-radio-js' value="searchAll">
			<label role="radio" tabindex="0" for="searchAll">
				<span class="checkBoxes__checkIcon">
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
						<circle cx="12" cy="12" r="8"/>
					</svg>
				</span>
				<span>{{ translations.WithAllWords }}</span>
			</label>
		</div>
		<div>
			<input id="searchAny" aria-label="tos-searchany" name="tos" type="radio" class='search-radio-js' value="searchAny">
			<label role="radio" tabindex="0" for="searchAny">
				<span class="checkBoxes__checkIcon">
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
						<circle cx="12" cy="12" r="8"/>
					</svg>
				</span>
				<span>{{ translations.WithAnyWord }}</span>
			</label>
		</div>
		<div>
			<input id="searchWild" aria-label="tos-searchwild" name="tos" type="radio" class='search-radio-js' value="searchWild">
			<label role="radio" tabindex="0" for="searchWild">
				<span class="checkBoxes__checkIcon">
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
						<circle cx="12" cy="12" r="8"/>
					</svg>
				</span>
				<span>{{ translations.WithPartOfWord }}</span>
			</label>
		</div>
	</div>

	{% unless customer.HidePrices -%}
		<h4>{{ translations.Price }}</h4>

		<div class="search-advanced-container__price">
			<strong class="bad-value-js hidden">{{ translations.BadPrice }}</strong>
			<div>
				<fieldset>
					<legend>{{ translations.RangeFrom }}</legend>
					<input id="min-price" aria-label="pricefrom" name="priceFrom" type="number" step="1" min="0" max="99999">
					<span>{{ customer.CurrencyExt }}</span>
				</fieldset>
				<span>&#8212;</span>
				<fieldset>
					<legend>{{ translations.RangeTo }}</legend>
					<input id="max-price" aria-label="priceto" name="priceTo" type="number" step="1" min="0" max="99999">
					<span>{{ customer.CurrencyExt }}</span>
				</fieldset>
			</div>
		</div>
	{% endunless -%}

	<div class="search-advanced-container__checkboxes checkBoxes__container">
		<h4>{{ translations.SearchArea }}</h4>

		<div class="search-advanced-container__checkboxes-two-columns">
			<input id="f-1" aria-label="fields" name="fields" type="checkbox" value="2" class="checkbox-input-js">
			<label role="checkbox" tabindex="0" aria-checked="false" for="f-1" class="search-advanced-container__checkboxes-two-columns">
				<span class="checkBoxes__checkIcon">
					<svg>
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{ settings.iconStyle }}"></use>
					</svg>
				</span>
				<span>{{ translations.ProductDescription }}</span>
			</label>
		</div>
		<div class="search-advanced-container__checkboxes-two-columns">
			<input id="f-2" aria-label="fields" name="fields" type="checkbox" value="4" class="checkbox-input-js">
			<label role="checkbox" tabindex="0" aria-checked="false" for="f-2">
				<span class="checkBoxes__checkIcon">
					<svg>
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{ settings.iconStyle }}"></use>
					</svg>
				</span>
				<span>{{ translations.ProductAttributes }}</span>
			</label>
		</div>
		<div class="search-advanced-container__checkboxes-two-columns">
			<input id="f-3" aria-label="fields" name="fields" type="checkbox" value="8" class="checkbox-input-js">
			<label role="checkbox" tabindex="0" aria-checked="false" for="f-3">
				<span class="checkBoxes__checkIcon">
					<svg>
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{ settings.iconStyle }}"></use>
					</svg>
				</span>
				<span>{{ translations.ProductCode }}</span>
			</label>
		</div>
		<div class="search-advanced-container__checkboxes-two-columns">
			<input id="f-4" aria-label="fields" name="fields" type="checkbox" value="128" class="checkbox-input-js">
			<label role="checkbox" tabindex="0" for="f-4">
				<span class="checkBoxes__checkIcon">
					<svg>
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{ settings.iconStyle }}"></use>
					</svg>
				</span>
				<span>{{ translations.Symbol }}</span>
			</label>
		</div>
		<div class="search-advanced-container__checkboxes-two-columns">
			<input id="f-5" aria-label="fields" name="fields" type="checkbox" value="256" class="checkbox-input-js">
			<label role="checkbox" tabindex="0" for="f-5">
				<span class="checkBoxes__checkIcon">
					<svg>
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{ settings.iconStyle }}"></use>
					</svg>
				</span>
				<span>{{ translations.EanCode }}</span>
			</label>
		</div>
		<div class="search-advanced-container__checkboxes-two-columns">
			<input id="f-6" aria-label="fields" name="fields" type="checkbox" value="512" class="checkbox-input-js">
			<label role="checkbox" tabindex="0" for="f-6">
				<span class="checkBoxes__checkIcon">
					<svg>
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{ settings.iconStyle }}"></use>
					</svg>
				</span>
				<span>{{ translations.ManufacturerCode }}</span>
			</label>
		</div>

		<h4>{{ translations.TypeOfProduct }}</h4>

		<div>
			<input id="fl-1" aria-label="flags" name="flags" type="checkbox" value="1" class="checkbox-input-js">
			<label role="checkbox" tabindex="0" for="fl-1">
				<span class="checkBoxes__checkIcon">
					<svg>
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{ settings.iconStyle }}"></use>
					</svg>
				</span>
				<span>{{ translations.WithPhoto }}</span>
			</label>
		</div>
		<div>
			<input id="fl-2" aria-label="flags" name="flags" type="checkbox" value="2" class="checkbox-input-js">
			<label role="checkbox" tabindex="0" for="fl-2">
				<span class="checkBoxes__checkIcon">
					<svg>
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{ settings.iconStyle }}"></use>
					</svg>
				</span>
				<span>{{ translations.NewProduct }}</span>
			</label>
		</div>
		<div>
			<input id="fl-3" aria-label="flags" name="flags" type="checkbox" value="4" class="checkbox-input-js">
			<label role="checkbox" tabindex="0" for="fl-3">
				<span class="checkBoxes__checkIcon">
					<svg>
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{ settings.iconStyle }}"></use>
					</svg>
				</span>
				<span>{{ translations.Promotion }}</span>
			</label>
		</div>
		<div>
			<input id="fl-4" aria-label="flags" name="flags" type="checkbox" value="8" class="checkbox-input-js">
			<label role="checkbox" tabindex="0" for="fl-4">
				<span class="checkBoxes__checkIcon">
					<svg>
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{ settings.iconStyle }}"></use>
					</svg>
				</span>
				<span>{{ translations.ProductFromNewsletter }}</span>
			</label>
		</div>
		<div>
			<input id="fl-5" aria-label="flags" name="flags" type="checkbox" value="16" class="checkbox-input-js">
			<label role="checkbox" tabindex="0" for="fl-5">
				<span class="checkBoxes__checkIcon">
					<svg>
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{ settings.iconStyle }}"></use>
					</svg>
				</span>
				<span>{{ translations.RecommendedProduct }}</span>
			</label>
		</div>
		<div>
			<input id="fl-6" aria-label="flags" name="flags" type="checkbox" value="32" class="checkbox-input-js">
			<label role="checkbox" tabindex="0" for="fl-6">
				<span class="checkBoxes__checkIcon">
					<svg>
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{ settings.iconStyle }}"></use>
					</svg>
				</span>
				<span>{{ translations.Sale }}</span>
			</label>
		</div>
		<div>
			<input id="fl-7" aria-label="flags" name="flags" type="checkbox" value="64" class="checkbox-input-js">
			<label role="checkbox" tabindex="0" for="fl-7">
				<span class="checkBoxes__checkIcon">
					<svg>
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{ settings.iconStyle }}"></use>
					</svg>
				</span>
				<span>{{ translations.ExtraQuality }}</span>
			</label>
		</div>
		<div>
			<input id="fl-8" aria-label="flags" name="flags" type="checkbox" value="128" class="checkbox-input-js">
			<label role="checkbox" tabindex="0" for="fl-8">
				<span class="checkBoxes__checkIcon">
					<svg>
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{ settings.iconStyle }}"></use>
					</svg>
				</span>
				<span>{{ translations.ExtraPrice }}</span>
			</label>
		</div>
		<div>
			<input id="fl-9" aria-label="flags" name="flags" type="checkbox" value="256" class="checkbox-input-js">
			<label role="checkbox" tabindex="0" for="fl-9">
				<span class="checkBoxes__checkIcon">
					<svg>
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{ settings.iconStyle }}"></use>
					</svg>
				</span>
				<span>{{ translations.BestReviewed }}</span>
			</label>
		</div>
		<div>
			<input id="fl-10" aria-label="flags" name="flags" type="checkbox" value="512" class="checkbox-input-js">
			<label role="checkbox" tabindex="0" for="fl-10">
				<span class="checkBoxes__checkIcon">
					<svg>
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{ settings.iconStyle }}"></use>
					</svg>
				</span>
				<span>{{ translations.SellerRecomendation }}</span>
			</label>
		</div>
		<div>
			<input id="fl-11" aria-label="flags" name="flags" type="checkbox" value="1024" class="checkbox-input-js">
			<label role="checkbox" tabindex="0" for="fl-11">
				<span class="checkBoxes__checkIcon">
					<svg>
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{ settings.iconStyle }}"></use>
					</svg>
				</span>
				<span>{{ translations.PointsProduct }}</span>
			</label>
		</div>
		{% assign sizeManufacturer = manufacturer-brand.Manufacturers | Size -%}
		{% assign sizeBrand =  manufacturer-brand.Brands | Size -%}

		{% if sizeManufacturer > 0 and settings.productListFilters__Manufacturer == 'Manufacturer_Yes' -%}
			<h4>{{ translations.Manufacturer }}</h4>

			{% for manufacturer in manufacturer-brand.Manufacturers -%}
				{% assign brands = "" -%}
				{% for brand in manufacturer.Brands -%}
					{% assign brands = brands | Append: brand.Name | Append: "," -%}
				{% endfor -%}
				
			<div class="checkBoxes__container--radio manufacture" data-brands="{{ brands }}" data-name="{{ manufacturer.Name }}">
				<input id="{{ manufacturer.Id }}m" aria-label="manufacturerid" name="manufacturerId" type="checkbox" value="{{ manufacturer.Id }}" >
				<label role="radio" tabindex="0" for="{{ manufacturer.Id }}m">
					<span class="checkBoxes__checkIcon">
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
							<circle cx="12" cy="12" r="8"/>
						</svg>
					</span>
					<span>{{ manufacturer.Name }}</span>
				</label>
			</div>
			{% endfor -%}
		{% endif -%}

		{% if sizeBrand > 0 and settings.productListFilters__Brand == 'Brand_Yes' -%}
			<h4>{{ translations.Brand }}</h4>

			{% for brand in manufacturer-brand.Brands -%}
			<div class="checkBoxes__container--radio brand" data-name="{{ brand.Name }}">
				<input id="{{ brand.Id }}b" aria-label="brandid" name="brandId" type="checkbox" value="{{ brand.Id }}" >
				<label role="radio" tabindex="0" for="{{ brand.Id }}b">
					<span class="checkBoxes__checkIcon">
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
							<circle cx="12" cy="12" r="8"/>
						</svg>
					</span>
					<span>{{ brand.Name }}</span>
				</label>
			</div>
			{% endfor -%}
		{% endif -%}
	</div>

	<div class="search-advanced-container__buttons">
		<button id="clear-button" class="pure-button">
			<span class="button__text">{{ translations.Clear }}</span>
		</button>
		<button id="search-button" class="primary-action-button">
			<span class="button__text">{{ translations.Search }}</span>
		</button>
	</div>
</section>
`